import EsusView from 'components/esus/EsusView'

export default function AtendimentoDomiciliarView() {
  return <EsusView url='/pec/user/relatorios/producao/analiticoAtendimentoDomiciliar' />
}
